(function () {
  function initCarousel(root) {
    if (root.dataset.mgReady) return;
    root.dataset.mgReady = '1';

    var track = root.querySelector('.mg-fnd__track');
    var slides = root.querySelectorAll('.mg-fnd__slide');
    var dots = root.querySelectorAll('[data-dot]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var count = root.querySelector('[data-count]');
    var total = slides.length;
    var idx = 0;

    function render() {
      track.style.transform = 'translateX(calc(-' + idx * 100 + '% - ' + idx * 40 + 'px))';
      slides.forEach(function (s, i) {
        if (i === idx) s.removeAttribute('inert');
        else s.setAttribute('inert', '');
      });
      dots.forEach(function (d, i) {
        if (i === idx) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      prev.disabled = idx === 0;
      next.disabled = idx === total - 1;
      if (count) count.textContent = '0' + (idx + 1) + ' / 0' + total;
    }

    function go(n) {
      idx = Math.max(0, Math.min(total - 1, n));
      render();
    }

    prev.addEventListener('click', function () { go(idx - 1); });
    next.addEventListener('click', function () { go(idx + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.dot, 10)); });
    });

    render();
  }

  function initElements(root) {
    root.querySelectorAll('.mg-fnd__el').forEach(function (el) {
      if (el.dataset.mgReady) return;
      el.dataset.mgReady = '1';

      function set(open) {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      el.addEventListener('mouseenter', function () { set(true); });
      el.addEventListener('mouseleave', function () { set(false); });
      el.addEventListener('click', function () {
        set(el.getAttribute('aria-expanded') !== 'true');
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          set(el.getAttribute('aria-expanded') !== 'true');
        }
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-mg-findings]').forEach(function (root) {
      initCarousel(root);
      initElements(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
